
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("90eyR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8dcf1ef71bcc172d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $h47gY = parcelRequire("h47gY");

var $iepag = parcelRequire("iepag");

var $jQpPN = parcelRequire("jQpPN");

var $5rzmK = parcelRequire("5rzmK");
let $8dcf1ef71bcc172d$var$counter = 0;
class $8dcf1ef71bcc172d$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.store = props.store ?? (0, $iepag.store);
    }
    componentDidMount() {
        $8dcf1ef71bcc172d$var$counter += 1;
        if ($8dcf1ef71bcc172d$var$counter > 1) throw new Error('Invalid state: Two flag applications mounted at the same time.');
    }
    componentWillUnmount() {
        $8dcf1ef71bcc172d$var$counter -= 1;
        this.store.dispatch((0, $jQpPN.reset)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5rzmK.default), null))));
    }
}

});
parcelRegister("aP411", function(module, exports) {
$parcel$export(module.exports, "default", () => $02914045d75bc0a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $02914045d75bc0a9$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $02914045d75bc0a9$var$appStyles = null;
var $02914045d75bc0a9$export$2e2bcd8739ae039 = $02914045d75bc0a9$var$AppStyle;

});

parcelRegister("5rzmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c1e272618bdb9ed$export$2e2bcd8739ae039);

var $jQpPN = parcelRequire("jQpPN");

var $jJoA9 = parcelRequire("jJoA9");

var $gnQAk = parcelRequire("gnQAk");

var $4wlW8 = parcelRequire("4wlW8");

var $5QTgA = parcelRequire("5QTgA");
var $4c1e272618bdb9ed$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        flags: (0, $jJoA9.getFlags)(state),
        PropBypass: $5QTgA.PropBypass
    }), {
    onDismissed: (0, $jQpPN.dismiss)
})((0, $4wlW8.default));

});
parcelRegister("jJoA9", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $4e55fbd8dfad788f$export$d5815430bcc75df0);
const $4e55fbd8dfad788f$export$d5815430bcc75df0 = (state)=>state.flags;

});

parcelRegister("4wlW8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a76d56b43fa5d0a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $crnx3 = parcelRequire("crnx3");

var $l5Z0K = parcelRequire("l5Z0K");

var $eSnSE = parcelRequire("eSnSE");

var $6Jc5E = parcelRequire("6Jc5E");

var $gbul2 = parcelRequire("gbul2");

var $dQpoy = parcelRequire("dQpoy");

var $7xE6h = parcelRequire("7xE6h");

var $idGBm = parcelRequire("idGBm");

var $kGj4V = parcelRequire("kGj4V");
/**
 * Manages and renders flag notifications, supporting dynamic appearances and behaviors. Incorporates
 * internationalization for adaptable message formatting and handles user interactions through
 * configurable actions. Designed to display transient, informative messages to users in a visually
 * consistent manner.
 */ // eslint-disable-next-line jira/react/no-class-components
class $0a76d56b43fa5d0a$var$Flags extends (0, $eJOHy.Component) {
    formatMessage(message) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        if (Array.isArray(message)) return formatMessage(...message);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(message)) return String(message);
        return formatMessage(message);
    }
    formatActions(actions) {
        return actions ? actions.map((action)=>({
                onClick: action.onClick,
                content: this.formatMessage(action.content),
                href: action.href,
                target: action.target
            })) : undefined;
    }
    renderConfigurableFlag(id, flagConfiguration) {
        const { type: type, title: title, description: description, isAutoDismiss: isAutoDismiss, actions: actions, appearance: appearance, testId: testId, error: error, traceId: traceId, icon: icon, onDismissed: onDismissed, delayAnnouncement: delayAnnouncement, messageId: messageId, messageType: messageType } = flagConfiguration;
        const defaultedIsAutoDismiss = isAutoDismiss === undefined ? type === 'success' || type === 'info' : isAutoDismiss;
        const isValidType = [
            'success',
            'error',
            'info',
            'warning'
        ].includes(type);
        let formattedDescription = description && this.formatMessage(description);
        if (error) {
            const errComponent = traceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbul2.ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Jc5E.ErrorHash), {
                error: error
            });
            // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            formattedDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formattedDescription), errComponent);
        }
        if (isValidType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQpoy.JiraCommonFlag), {
            key: id,
            id: id,
            flagType: type,
            icon: icon,
            title: this.formatMessage(title),
            description: formattedDescription,
            isAutoDismiss: defaultedIsAutoDismiss,
            actions: this.formatActions(actions),
            appearance: appearance,
            testId: testId,
            onDismissed: onDismissed,
            messageId: messageId ?? `flag-app.jira-common-flag.${id}`,
            messageType: messageType ?? 'transactional',
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            }
        });
        return null;
    }
    render() {
        const { flags: flags, onDismissed: onDismissed } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
            sourceName: "flag",
            sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xE6h.default), {
            onDismissed: onDismissed
        }, (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))(flags.map((flagInstance)=>{
            const { id: id, flag: flag } = flagInstance;
            // @ts-expect-error - TS2339 - Property 'render' does not exist on type 'Flag'.
            if (flag.render !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagCustom'.
                const flagCustom = flag;
                return flagCustom.render({
                    key: id
                });
            }
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'Flag'.
            if (flag.type !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagConfiguration'.
                const flagConfiguration = flag;
                const comp = this.renderConfigurableFlag(id, flagConfiguration);
                if (comp) return comp;
                (0, $eSnSE.default).safeErrorWithoutCustomerData('flags.view', `There was a problem rendering a flag of type: ${flagConfiguration.type}`);
                return null;
            }
            // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagComponent'.
            const FlagComponent = flag;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, {
                key: id,
                id: id,
                onDismissed: onDismissed
            });
        }))));
    }
}
var $0a76d56b43fa5d0a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($0a76d56b43fa5d0a$var$Flags);

});
parcelRegister("crnx3", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $90ea429f86967b42$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $90ea429f86967b42$var$compact;

});

parcelRegister("l5Z0K", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $f5b964216372e7cd$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f5b964216372e7cd$var$isString(value) {
    return typeof value == 'string' || !$4sprp(value) && $7gKgM(value) && $1O9y6(value) == $f5b964216372e7cd$var$stringTag;
}
module.exports = $f5b964216372e7cd$var$isString;

});

parcelRegister("6Jc5E", function(module, exports) {
$parcel$export(module.exports, "ErrorHash", () => $72c5ec6e6399ad44$export$db1607d938d7ca33);

var $eJOHy = parcelRequire("eJOHy");

var $eS29z = parcelRequire("eS29z");

var $jLjxj = parcelRequire("jLjxj");

var $5UoqD = parcelRequire("5UoqD");
const $72c5ec6e6399ad44$export$db1607d938d7ca33 = ({ error: error })=>{
    const errorHash = (0, $jLjxj.getErrorHash)(error);
    const source = `Hash ${errorHash}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHash",
        attributes: {
            errorHash: errorHash
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UoqD.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHash"
    })));
};

});
parcelRegister("5UoqD", function(module, exports) {
$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $29a916468b8bbb25$export$ced1fc74d907d387);

var $eJOHy = parcelRequire("eJOHy");

var $2NQrv = parcelRequire("2NQrv");

var $lRrud = parcelRequire("lRrud");
var $e7uOb = parcelRequire("e7uOb");

var $80EWQ = parcelRequire("80EWQ");
const $29a916468b8bbb25$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $29a916468b8bbb25$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80EWQ.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80EWQ.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2NQrv.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $29a916468b8bbb25$var$wrapperStyles = (0, $e7uOb.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("2NQrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $0114227003df2b04$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $8QsGd = parcelRequire("8QsGd");

var $bgdbt = parcelRequire("bgdbt");

var $1xJVU = parcelRequire("1xJVU");

var $fKew6 = parcelRequire("fKew6");
const $0114227003df2b04$var$getCodeBlockStyles = {
    root: "_2rko12b0 _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srn17d7 _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gww7y _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $0114227003df2b04$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $bgdbt.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $8QsGd.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $1xJVU.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKew6.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            $0114227003df2b04$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $0114227003df2b04$var$getCodeBlockStyles.shouldWrapLongLines : $0114227003df2b04$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $0114227003df2b04$var$getCodeBlockStyles.showLineNumbers : $0114227003df2b04$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $0114227003df2b04$export$2e2bcd8739ae039 = $0114227003df2b04$var$CodeBlock;

});
parcelRegister("8QsGd", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $6b36594bef5df9e6$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $6b36594bef5df9e6$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $6b36594bef5df9e6$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$6b36594bef5df9e6$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $6b36594bef5df9e6$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $6b36594bef5df9e6$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $6b36594bef5df9e6$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$6b36594bef5df9e6$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $6b36594bef5df9e6$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("bgdbt", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $7ca00c80d741cece$export$cb7aec0206b595d2);
const $7ca00c80d741cece$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("1xJVU", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $d979ab5420f2a4ad$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $eng0k = parcelRequire("eng0k");
const $d979ab5420f2a4ad$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $eng0k.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("eng0k", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $2050a87d1e273f83$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $2050a87d1e273f83$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});


parcelRegister("fKew6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6bbad18679dafe0$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $iV9Xv = parcelRequire("iV9Xv");
var $e6bbad18679dafe0$export$2e2bcd8739ae039 = (0, $iV9Xv.default);

});
parcelRegister("iV9Xv", function(module, exports) {
$parcel$export(module.exports, "default", () => $72c16d3c7e213e11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kabwT = parcelRequire("kabwT");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $72c16d3c7e213e11$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $kabwT.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $72c16d3c7e213e11$var$asyncGenerator = $72c16d3c7e213e11$var$generator({
    loader: ()=>(parcelRequire("5bzOJ")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $72c16d3c7e213e11$export$2e2bcd8739ae039 = $72c16d3c7e213e11$var$asyncGenerator;

});
parcelRegister("kabwT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bb7054e8ace1d0c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4iNLc = parcelRequire("4iNLc");

var $2f3ln = parcelRequire("2f3ln");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $1bb7054e8ace1d0c$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $4iNLc.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $2f3ln.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $1bb7054e8ace1d0c$export$2e2bcd8739ae039 = $1bb7054e8ace1d0c$var$Highlight;

});
parcelRegister("4iNLc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4b258af6b65f2cd$export$2e2bcd8739ae039);

var $8EiUG = parcelRequire("8EiUG");

var $lTAsP = parcelRequire("lTAsP");

var $cXuhm = parcelRequire("cXuhm");

var $JxfRh = parcelRequire("JxfRh");
const $c4b258af6b65f2cd$var$newLineRegex = /\n/g;
function $c4b258af6b65f2cd$var$getNewLines(str) {
    return str.match($c4b258af6b65f2cd$var$newLineRegex);
}
function $c4b258af6b65f2cd$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $JxfRh.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $8EiUG.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $cXuhm.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $c4b258af6b65f2cd$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $lTAsP.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $lTAsP.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("8EiUG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5441b016daa6ecf4$export$2e2bcd8739ae039);

var $lTAsP = parcelRequire("lTAsP");

var $gDO3T = parcelRequire("gDO3T");
function $5441b016daa6ecf4$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $lTAsP.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $gDO3T.default)(lineNumber));
            return children;
        }
    };
}
var $5441b016daa6ecf4$export$2e2bcd8739ae039 = $5441b016daa6ecf4$var$createLineGenerator;

});
parcelRegister("lTAsP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b641c677d20aa442$export$2e2bcd8739ae039);

var $gDO3T = parcelRequire("gDO3T");
function $b641c677d20aa442$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $gDO3T.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $gDO3T.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("gDO3T", function(module, exports) {
$parcel$export(module.exports, "default", () => $98d498d0e86a8f4a$export$2e2bcd8739ae039);
function $98d498d0e86a8f4a$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("cXuhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd68c9bf7d1a5163$export$2e2bcd8739ae039);

var $lTAsP = parcelRequire("lTAsP");
function $fd68c9bf7d1a5163$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $lTAsP.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $fd68c9bf7d1a5163$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("JxfRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $adf0827acf70ad57$export$2e2bcd8739ae039);
function $adf0827acf70ad57$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("2f3ln", function(module, exports) {
$parcel$export(module.exports, "default", () => $72fc0f59f0f4c772$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1whNU = parcelRequire("1whNU");
function $72fc0f59f0f4c772$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $1whNU.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("1whNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0060ea955eaca50e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8CUGr = parcelRequire("8CUGr");

var $TDHoR = parcelRequire("TDHoR");

var $eOtRS = parcelRequire("eOtRS");
function $0060ea955eaca50e$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $0060ea955eaca50e$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $TDHoR.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8CUGr.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $eOtRS.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $0060ea955eaca50e$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("8CUGr", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe02df81c4cea2d3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aFF42 = parcelRequire("aFF42");

var $jtpC7 = parcelRequire("jtpC7");
function $fe02df81c4cea2d3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aFF42.default), {
        content: label,
        tag: $fe02df81c4cea2d3$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jtpC7.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jtpC7.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $fe02df81c4cea2d3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("jtpC7", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $a576c35238416ce6$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $guWvZ = parcelRequire("guWvZ");
const $a576c35238416ce6$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $a576c35238416ce6$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $a576c35238416ce6$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $a576c35238416ce6$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guWvZ.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $a576c35238416ce6$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("TDHoR", function(module, exports) {
$parcel$export(module.exports, "default", () => $64c7bf235898529d$export$2e2bcd8739ae039);
const $64c7bf235898529d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $64c7bf235898529d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($64c7bf235898529d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("eOtRS", function(module, exports) {
$parcel$export(module.exports, "default", () => $24dfff9b8c047025$export$2e2bcd8739ae039);

var $1whNU = parcelRequire("1whNU");
function $24dfff9b8c047025$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $1whNU.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("5bzOJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("asN81").then(()=>parcelRequire('5eKjD'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});






parcelRegister("80EWQ", function(module, exports) {
$parcel$export(module.exports, "CopyAction", () => $c95d22f1270785ad$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $c95d22f1270785ad$export$37ab3bdebc286ca);

var $eJOHy = parcelRequire("eJOHy");

var $4asqs = parcelRequire("4asqs");

var $kwDnL = parcelRequire("kwDnL");

var $lRrud = parcelRequire("lRrud");
var $e7uOb = parcelRequire("e7uOb");

var $kRgKj = parcelRequire("kRgKj");

var $8g8TA = parcelRequire("8g8TA");
const $c95d22f1270785ad$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $c95d22f1270785ad$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)($c95d22f1270785ad$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($c95d22f1270785ad$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($c95d22f1270785ad$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($c95d22f1270785ad$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8g8TA.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kwDnL))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $c95d22f1270785ad$var$stopPropagation = (event)=>event.stopPropagation();
const $c95d22f1270785ad$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $c95d22f1270785ad$var$absolutePositionWrapperStyles,
        onMouseDown: $c95d22f1270785ad$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4asqs.default), {
        label: "actions"
    }, children));
const $c95d22f1270785ad$var$absolutePositionWrapperStyles = (0, $e7uOb.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("kwDnL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef15584ac4d18d17$var$_react = $ef15584ac4d18d17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ef15584ac4d18d17$var$_copy = $ef15584ac4d18d17$var$_interopRequireDefault((parcelRequire("khRWD")));

var $ef15584ac4d18d17$var$_copy2 = $ef15584ac4d18d17$var$_interopRequireDefault((parcelRequire("1JjIz")));
function $ef15584ac4d18d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef15584ac4d18d17$var$CopyIcon = (props)=>/*#__PURE__*/ $ef15584ac4d18d17$var$_react.default.createElement($ef15584ac4d18d17$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $ef15584ac4d18d17$var$_copy2.default
    }, props));
$ef15584ac4d18d17$var$CopyIcon.displayName = 'CopyIconMigration';
var $ef15584ac4d18d17$var$_default = module.exports.default = $ef15584ac4d18d17$var$CopyIcon;

});
parcelRegister("1JjIz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $142949f5e8fdcaf5$var$_react = $142949f5e8fdcaf5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4PsdO = parcelRequire("4PsdO");
function $142949f5e8fdcaf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $142949f5e8fdcaf5$var$CopyIcon = (props)=>/*#__PURE__*/ $142949f5e8fdcaf5$var$_react.default.createElement($4PsdO.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$142949f5e8fdcaf5$var$CopyIcon.displayName = 'CopyIcon';
var $142949f5e8fdcaf5$var$_default = module.exports.default = $142949f5e8fdcaf5$var$CopyIcon;

});


parcelRegister("8g8TA", function(module, exports) {
$parcel$export(module.exports, "Action", () => $0f6ca96aab29dfce$export$e19cd5f9376f8cee);

var $eJOHy = parcelRequire("eJOHy");

var $dZl0l = parcelRequire("dZl0l");

var $aFF42 = parcelRequire("aFF42");
const $0f6ca96aab29dfce$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFF42.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dZl0l.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("gbul2", function(module, exports) {
$parcel$export(module.exports, "ErrorHashAndTraceId", () => $9aac1175c75430b3$export$61354a7dde2c2d3c);

var $eJOHy = parcelRequire("eJOHy");

var $eS29z = parcelRequire("eS29z");

var $jLjxj = parcelRequire("jLjxj");

var $5UoqD = parcelRequire("5UoqD");
const $9aac1175c75430b3$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $jLjxj.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UoqD.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});

parcelRegister("dQpoy", function(module, exports) {
$parcel$export(module.exports, "JiraCommonFlag", () => $a6fea93fe89aa5b7$export$1d9a3324fc0eb52);

var $eJOHy = parcelRequire("eJOHy");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $iowLF = parcelRequire("iowLF");

var $6Xm0Y = parcelRequire("6Xm0Y");
const $a6fea93fe89aa5b7$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iowLF.ChoreographerCommonFlag), props);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Xm0Y.default), rest);
};

});
parcelRegister("iowLF", function(module, exports) {
$parcel$export(module.exports, "ChoreographerCommonFlag", () => $44d26709c132e3e8$export$ef12cdd486f28a7a);

var $5hQBi = parcelRequire("5hQBi");

var $6Xm0Y = parcelRequire("6Xm0Y");
const $44d26709c132e3e8$export$ef12cdd486f28a7a = (0, $5hQBi.withChoreographedRender)((0, $6Xm0Y.default));

});
parcelRegister("6Xm0Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $0be7d05bc00f2aa1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $abiu8 = parcelRequire("abiu8");
var $e5Y7O = parcelRequire("e5Y7O");

var $lRrud = parcelRequire("lRrud");
var $e7uOb = parcelRequire("e7uOb");

var $lRq8t = parcelRequire("lRq8t");

var $1tPdA = parcelRequire("1tPdA");

var $6byBy = parcelRequire("6byBy");
const $0be7d05bc00f2aa1$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
// standard delay time in ms, added for SR users to announce the status flag
const $0be7d05bc00f2aa1$var$ANNOUNCEMENT_DELAY = 2500;
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $0be7d05bc00f2aa1$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement = $0be7d05bc00f2aa1$var$ANNOUNCEMENT_DELAY, isAutoDismiss: isAutoDismiss, ...flagProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const StyledIcon = flagProps.appearance ? (0, $1tPdA.boldIconMap)[flagType] : (0, $1tPdA.iconMap)[flagType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $0be7d05bc00f2aa1$var$containerStyles,
        ...flagProps.testId && {
            'data-test-id': flagProps.testId
        }
    }, isAutoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abiu8.default), {
        testId: `${$0be7d05bc00f2aa1$export$b020578ce674a70f}-auto-dismiss`,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        // @ts-expect-error - TS2881 Typescript 5.9.2 upgrade
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StyledIcon, {
            label: formatMessage((0, $6byBy.messages)[flagType])
        }) ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5Y7O.default), {
        testId: $0be7d05bc00f2aa1$export$b020578ce674a70f,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        // @ts-expect-error - TS2881 Typescript 5.9.2 upgrade
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StyledIcon, {
            label: formatMessage((0, $6byBy.messages)[flagType])
        }) ?? null
    }));
};
var $0be7d05bc00f2aa1$export$2e2bcd8739ae039 = $0be7d05bc00f2aa1$var$CommonFlag;
const $0be7d05bc00f2aa1$var$containerStyles = (0, $e7uOb.xcss)({
    wordWrap: 'break-word'
});

});
parcelRegister("1tPdA", function(module, exports) {
$parcel$export(module.exports, "iconMap", () => $92136c069116dd31$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $92136c069116dd31$export$6c71c95b1e390472);

var $mzzoj = parcelRequire("mzzoj");
const $92136c069116dd31$export$6d49a893c897b0cc = {
    error: (0, $mzzoj.IconError),
    success: (0, $mzzoj.IconSuccess),
    info: (0, $mzzoj.IconInfo),
    warning: (0, $mzzoj.IconWarning)
};
const $92136c069116dd31$export$6c71c95b1e390472 = {
    error: (0, $mzzoj.BoldIconError),
    success: (0, $mzzoj.BoldIconSuccess),
    info: (0, $mzzoj.BoldIconInfo),
    warning: (0, $mzzoj.BoldIconWarning)
};

});
parcelRegister("mzzoj", function(module, exports) {
$parcel$export(module.exports, "IconError", () => $adc7dc7438e7a666$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $adc7dc7438e7a666$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $adc7dc7438e7a666$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $adc7dc7438e7a666$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $adc7dc7438e7a666$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $adc7dc7438e7a666$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $adc7dc7438e7a666$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $adc7dc7438e7a666$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $b1kR7 = parcelRequire("b1kR7");

var $7VyXN = parcelRequire("7VyXN");

var $fpmVH = parcelRequire("fpmVH");

var $eK4H9 = parcelRequire("eK4H9");
const $adc7dc7438e7a666$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc7dc7438e7a666$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-danger, #C9372C)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VyXN))), {
        spacing: "spacious",
        label: label
    }));
const $adc7dc7438e7a666$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc7dc7438e7a666$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-success, #22A06B)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b1kR7))), {
        spacing: "spacious",
        label: label
    }));
const $adc7dc7438e7a666$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc7dc7438e7a666$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-discovery, #8270DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fpmVH))), {
        spacing: "spacious",
        label: label
    }));
const $adc7dc7438e7a666$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc7dc7438e7a666$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-warning, #E56910)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eK4H9))), {
        spacing: "spacious",
        label: label
    }));
const $adc7dc7438e7a666$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VyXN))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-danger, #C9372C)"
    });
const $adc7dc7438e7a666$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b1kR7))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-success, #22A06B)"
    });
const $adc7dc7438e7a666$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fpmVH))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-discovery, #8270DB)"
    });
const $adc7dc7438e7a666$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eK4H9))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-warning, #E56910)"
    });
const $adc7dc7438e7a666$export$8f314e512d92575f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $awdRS.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6byBy", function(module, exports) {
$parcel$export(module.exports, "messages", () => $eacf965c247b4326$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file

var $7qGN1 = parcelRequire("7qGN1");
const $eacf965c247b4326$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("7xE6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $81717f6310abc3dd$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$81717f6310abc3dd$export$2e2bcd8739ae039 = (0, $2pgjF.FlagGroup);

});

parcelRegister("idGBm", function(module, exports) {
$parcel$export(module.exports, "injectIntlV2", () => $c35e98ccc24112a8$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $cjwij = parcelRequire("cjwij");

var $lRq8t = parcelRequire("lRq8t");
const $c35e98ccc24112a8$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $c35e98ccc24112a8$var$getDisplayName(Component) {
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $c35e98ccc24112a8$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $lRq8t.default)();
        const intlRef = (0, $eJOHy.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$c35e98ccc24112a8$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(WithIntl, WrappedComponent);
};

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("5QTgA", function(module, exports) {
$parcel$export(module.exports, "PropBypass", () => $4662d8e515bfd4f9$export$84bef06589f4b13a);
const $4662d8e515bfd4f9$export$84bef06589f4b13a = ({ children: children, key: key, ...props })=>children(props);

});




//# sourceMappingURL=async-flags.efb66db6.js.map
